module.exports = __webpack_public_path__ + "static/media/corporate-services-img64.0adf42a7.jpg";